import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getEmailContacts } from "../../api/axios"
import { day } from "../../utilities/Utils"
import useAuth from "../../hooks/useAuth";
import LoadingContainer from "../../components/LoadingContainer";

const PAGE_SIZE = 20;

const getContactStatus = (contact) => {
  const postfixStatus = contact.postfix_status;

  if (contact.date_unsubscribed) {
    return { label: "Baja", className: "table-status--warn" };
  }

  if (Number(contact.bounced) === 1 || postfixStatus === "bounced") {
    return { label: "Rebotado", className: "table-status--warn" };
  }

  if (postfixStatus) {
    return {
      label: postfixStatus,
      className: postfixStatus === "sent" ? "table-status--ok" : "table-status--warn",
    };
  }

  if (contact.date_sent) {
    return { label: "Enviado", className: "table-status--ok" };
  }

  return { label: "-", className: "table-status--neutral" };
};

const EmailContactsTable = (props) => {

  const [isLoading, setIsLoading] = useState(true);
  const [contacts, setContacts] = useState([]);
  const [totalContacts, setTotalContacts] = useState(0);
  const [page, setPage] = useState(1);

  const { auth } = useAuth();
  const { idEmail, status, email } = props.params;

  useEffect(() => {
    setPage(1);
  }, [idEmail, status, email]);

  useEffect(() => {

    let ignore = false;

    const fetchData = async () => {
      
      setIsLoading(true);
      
      try {        
        
        const data = await getEmailContacts({
          idEmail,
          props: {
            params: {
              status,
              email,
              page,
              limit: PAGE_SIZE,
            },
          },
          auth,
        });

        if (ignore) {
          return;
        }

        setContacts(Array.isArray(data.results) ? data.results : []);
        setTotalContacts(Number(data.count) || 0);
      } catch (error) {
  
        if (!ignore) {
          setContacts([]);
          setTotalContacts(0);
        }
  
      }
  
      if (!ignore) {
        setIsLoading(false);
      }
  
    };

    fetchData();

    return () => {
      ignore = true;
    };
      
  }, [idEmail, status, email, page, auth]);


  const hasContacts = Array.isArray(contacts) && contacts.length > 0;
  const totalPages = Math.max(1, Math.ceil(totalContacts / PAGE_SIZE));
  const firstResult = totalContacts === 0 ? 0 : ((page - 1) * PAGE_SIZE) + 1;
  const lastResult = Math.min(page * PAGE_SIZE, totalContacts);
  const canGoBack = page > 1;
  const canGoForward = page < totalPages;

  const handlePrevious = () => {
    if (canGoBack) {
      setPage((currentPage) => currentPage - 1);
    }
  };

  const handleNext = () => {
    if (canGoForward) {
      setPage((currentPage) => currentPage + 1);
    }
  };

  return (

    <LoadingContainer isLoading={isLoading}>
      <div className="email-contacts-results">
          
        <table className="table table--enhanced table--wide">
                        
          <thead>
              <tr>
                  <td>#</td> 
                  <td>Email</td> 
                  <td className="c">Enviado</td> 
                  <td className="c">Abierto</td> 
                  <td className="c">Baja</td> 
                  <td className="c">Estado</td> 
              </tr>
          </thead>
          <tbody>

              {!isLoading && !hasContacts && (
                <tr><td colSpan="6" className="c loading">No se encontraron resultados</td></tr>
              )}
              {!isLoading && hasContacts && contacts.map( item => {
                const status = getContactStatus(item);

                return (
                  <tr key={item.id}>
                      
                      <td className="c"><span className="table-id-pill">{item.id}</span></td>
                      <td>
                        {item.contact_id ? (
                          <Link className="vinculo table-email" to={`/contacts/${item.contact_id}/email-timeline`}>
                            {item.email}
                          </Link>
                        ) : (
                          <span className="table-email">{item.email}</span>
                        )}
                      </td>
                      <td className="c">{day(item.date_sent)}</td>
                      <td className="c">{day(item.date_opened)}</td>
                      <td className="c baja">{day(item.date_unsubscribed)}</td>
                      <td className="c">
                        <span className={`table-status ${status.className}`}>
                          {status.label}
                        </span>
                      </td>
                      
                  </tr>
                );

              })}
              
          </tbody>

        </table>
        {!isLoading && totalContacts > 0 && (
          <div className="table-pagination">
            <span>
              Mostrando {firstResult}-{lastResult} de {totalContacts}
            </span>
            <div className="table-pagination__controls">
              <button
                type="button"
                className="button-outline"
                onClick={handlePrevious}
                disabled={!canGoBack}
              >
                Anterior
              </button>
              <span>Página {page} de {totalPages}</span>
              <button
                type="button"
                className="button-outline"
                onClick={handleNext}
                disabled={!canGoForward}
              >
                Siguiente
              </button>
            </div>
          </div>
        )}
      </div>
    </LoadingContainer>
    
    )
}

export default EmailContactsTable
